export default {
  "content": "<path d=\"M23.333 7.395H10a3.333 3.333 0 00-3.333 3.333v16.667m0 0v3.333A3.333 3.333 0 0010 34.062h20a3.333 3.333 0 003.333-3.334v-6.666M6.667 27.395l7.643-7.643a3.333 3.333 0 014.713 0l4.31 4.31m10-6.667v6.667m0 0l-2.643-2.644a3.333 3.333 0 00-4.713 0l-2.644 2.644m0 0l3.334 3.333m3.333-20h6.667m-3.334-3.333v6.666m-10 3.334h.017\" stroke=\"#6B7280\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "40",
    "height": "41",
    "viewBox": "0 0 40 41",
    "fill": "none"
  }
};